import { render, staticRenderFns } from "./train-list.vue?vue&type=template&id=29b0aff1&scoped=true&"
import script from "./train-list.vue?vue&type=script&lang=js&"
export * from "./train-list.vue?vue&type=script&lang=js&"
import style0 from "./train-list.vue?vue&type=style&index=0&id=29b0aff1&lang=less&scoped=true&"
import style1 from "./train-list.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b0aff1",
  null
  
)

export default component.exports